import React from 'react';
import UnifiedOrderPage from './UnifiedOrderPage';

// Main Edit Order Page Component
const EditOrderPage: React.FC = () => {
  return <UnifiedOrderPage mode="edit" />;
};

export default EditOrderPage;